import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ActionsEnum } from 'src/app/models/ActionsEnum';
import { FloatingMenuItem } from 'src/app/models/menus/FloatingMenuItem';
import { SceneService } from 'src/app/services/scene/scene.service';

@Component({
  selector: 'app-floating-menu',
  templateUrl: './floating-menu.component.html',
  styleUrls: ['./floating-menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FloatingMenuComponent implements OnInit {

  @Output() hideMenu: EventEmitter<boolean>;

  public items: FloatingMenuItem[];
  public hide = false;

  constructor(private sceneService: SceneService) { 
    this.hideMenu = new EventEmitter();
  }

  ngOnInit(): void {
    this.items = this.sceneService.getFloatingMenuItems();
  }

  doAction(item:FloatingMenuItem){
    switch (item.type) {
      case ActionsEnum.HIDE_UI:
        this.hide = !this.hide;
        this.hideMenu.emit(this.hide);
     //   this.changeTexture(item.getMesh());
        break;
      default:
        this.sceneService.doAction(item);
    //   case ActionsEnum.CHANGE_POV:
    //     this.moveTo(this.data.pov, item.getMesh());
    //     break;
    //   case ActionsEnum.RUN_ANIMATIONS:
    //     this.runAnimationFor(item.getMesh());
    //     break;
    //   case ActionsEnum.DEBUG_LAYER:
    //     isEnabled ? this.scene.debugLayer.show() : this.scene.debugLayer.hide();
    //     break;
    }
    //this.sceneService.doAction()
  }

}
